import { Component, Inject } from "@angular/core";
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog,
} from "@angular/material/dialog";
import { DialogResult, DialogResultType } from "../DialogResult";
import { Observable } from "rxjs";
import { InteractiveFilter, InteractiveBookmark } from "../../api/models";

export interface InteractMenuDialogData {
  modInteractve: boolean;
  isOwner: boolean;

  selectedAction: string;
}

@Component({
  selector: "interact-menu-dialog",
  templateUrl: "./interact-menu-dialog.component.html",
})
export class InteractMenuDialogComponent {
  public Result: DialogResult;

  constructor(
    public dialogRef: MatDialogRef<InteractMenuDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: InteractMenuDialogData
  ) {
    this.Result = new DialogResult();
    this.Result.ResultType = DialogResultType.Cancel;
    this.Result.ResultData = null;
  }

  onCancelClick(): void {
    this.dialogRef.close(this.Result);
  }

  onConfirmClick(): void {
    this.Result.ResultType = DialogResultType.Ok;
    this.Result.ResultData = this.data;
    this.dialogRef.close(this.Result);
  }

  closeForm(selectedAction: string) {
    this.Result.ResultType = DialogResultType.Ok;
    this.data.selectedAction = selectedAction;
    this.Result.ResultData = this.data;
    this.dialogRef.close(this.Result);
  }

  applyFilter() {
    this.closeForm("applyFilter");
  }

  editFilter() {
    this.closeForm("editFilter");
  }

  createFilter() {
    this.closeForm("createFilter");
  }

  deleteFilter() {
    this.closeForm("deleteFilter");
  }

  applyBookmark() {
    this.closeForm("applyBookmark");
  }

  editBookmark() {
    this.closeForm("editBookmark");
  }

  createBookmark() {
    this.closeForm("createBookmark");
  }

  deleteBookmark() {
    this.closeForm("deleteBookmark");
  }

  save() {
    this.closeForm("save");
  }

  saveAs() {
    this.closeForm("saveAs");
  }

  updateSharing() {
    this.closeForm("updateSharing");
  }
}
